import React from "react";
import { useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import AccountingRPT from "./accountingRPT";
import { convertToTreeData } from "../../../../services/accountIndex-services";

const defaultAutos = {
  Safes: [],
};

export default function AccountingRPTCon() {
  const tb = {
    wait: true,
    Branches: true,
    costcenters: true,
    AccountsIndex: true,
    omlat: true,
    stor: sto,
    parms: { safe: -1 },
  };
  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb
  );
  const url = uri + "accounts-index/getAll";
  const {
    data: accounts,
    fetching,
    fetchURL,
  } = useFetchURL({
    ...{ url, mapFunction: convertToTreeData, dependencyArray: [] },
  });

  if (fetchAll || !AutoOptions?.center ||  accounts?.length == 0) return <></>;

  return (
    <AccountingRPT
      {...{
        AutoOptions: AutoOptions?.center ? AutoOptions : defaultAutos,
        accounts: accounts?.length > 0 ? accounts : [],
      }}
    />
  );
}
